export const containerStyles = {
  padding: "20px",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  maxWidth: "1200px",
  margin: "0 auto",
  backgroundColor: "#f5f6fa"
};

export const headerStyles = {
  marginBottom: "24px"
};

export const headerTitleSectionStyles = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px"
};

export const titleStyles = {
  margin: "0 0 20px 0",
  color: "#2c3e50",
  fontSize: "28px",
  fontWeight: "600"
};

export const loadingStyles = {
  textAlign: "center",
  padding: "40px",
  fontSize: "18px",
  color: "#555",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px"
};

export const spinnerStyles = {
  border: "3px solid #f3f3f3",
  borderTop: "3px solid #3498db",
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  animation: "spin 1s linear infinite"
};